module.exports = __webpack_public_path__ + "img/newsletter.6e454eaa.png";